<template>
    <hts-form-select
        v-model="cValue"
        :label="label"
        :items="currencies"
        :prop="prop"
        :name="name"
        :required="required"
        :multiple="multiple"
        :disabled="disabled" />
</template>
<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  label: { type: String, default: () => $t('labels.accountUseCurrency') },
  prop: { type: String, default: '' },
  name: { type: String, default: '' },
  required: { type: Boolean, default: false },
  multiple: { type: Boolean, default: false },
  text: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false }
})

const emits = defineEmits(['update:modelValue'])

const { modelValue } = toRefs(props)

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const currencies = ref([
  {
    value: 'USD',
    label: $t('labels.USD')
  },
  {
    value: 'VND',
    label: $t('labels.VND')
  }
])
</script>
